import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { useRef } from 'react';

import AutomatedCatalogCarouselCardCatalogInfo from '@/components/FeaturedCatalogCarousel/components/AutomatedCatalogCarouselCard/components/CatalogInfo/AutomatedCatalogCarouselCardCatalogInfo';
import AutomatedCatalogCarouselCardItemImages from '@/components/FeaturedCatalogCarousel/components/AutomatedCatalogCarouselCard/components/ItemImages/AutomatedCatalogCarouselCardItemImages';
import { useTrackAndNavigateCatalogCardClick } from '@/components/FeaturedCatalogCarousel/components/AutomatedCatalogCarouselCard/hooks/useTrackAndNavigateCatalogCardClick';
import { useTrackCardVisibility } from '@/components/FeaturedCatalogCarousel/components/AutomatedCatalogCarouselCard/hooks/useTrackCardVisibility';

type Props = {
    cardWidth?: number;
    catalogId: number;
};

const AutomatedCatalogCarouselCardDesktop = ({ cardWidth, catalogId }: Props) => {
    const cardRef = useRef<HTMLDivElement>(null);

    const trackCardClick = useTrackAndNavigateCatalogCardClick(catalogId);
    useTrackCardVisibility({ cardRef, catalogId });

    return (
        <section
            className={cn(
                'lgMin gap-lg rounded-md bg-linear-to-b/srgb from-background-info-dark to-surface-900 p-md hover:cursor-pointer',
                cardWidth && 'shrink-0 overflow-hidden'
            )}
            data-testid="featuredAuctionsCarousel.desktopCard"
            onClick={trackCardClick}
            ref={cardRef}
            role="link"
            style={{
                ...(cardWidth && {
                    maxWidth: cardWidth,
                    minWidth: cardWidth,
                    width: cardWidth,
                }),
            }}
        >
            <AutomatedCatalogCarouselCardItemImages
                catalogId={catalogId}
                shouldFillCardWidth={Boolean(cardWidth)}
            />
            <AutomatedCatalogCarouselCardCatalogInfo
                catalogId={catalogId}
                className="mt-md"
            />
        </section>
    );
};

export default AutomatedCatalogCarouselCardDesktop;
